import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  ARTICLES_DELETE_MUTATION_KEY,
  ARTICLES_DELETE_URL,
  ARTICLES_LIST_QUERY_KEY,
  ARTICLES_PERMISSIONS,
} from '../constants';

export default function useArticlesDeleteMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [ARTICLES_DELETE_MUTATION_KEY],
    mutationFn: (id) => fetchDelete<void>(
      ARTICLES_DELETE_URL,
      {
        permission: ARTICLES_PERMISSIONS.DESTROY,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [ARTICLES_LIST_QUERY_KEY] });

      displayPresetToast('removed');
    },
  });
}
